import {listener, str_random} from "../../../../modules/vegas/js/util";
import axios from "axios";

listener('click', 'input[data-autocomplete]', (input, e) => {
	let route = input.dataset.autocomplete;

	let list;
	if (!input.list) {
		let listId = 'list-' + str_random(10);
		list = document.createElement('datalist');
		list.id = listId;

		input.setAttribute('list', listId)
		input.insertAdjacentElement('afterend', list);

		axios.get(route).then(response => {
			list.innerHTML = '';

			Array.from(response.data.items || []).forEach(v => {
				list.appendChild(
					new Option('', v)
				);
			});
		});
	}
});
